import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountCrmModule} from 'src/openapi/admin/models/AccountCrmModule';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultCrmIntegrationSlice = getCachedTableDataSlice<
    Record<string, AccountCrmModule>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultCrmIntegration');

export const accountSearchResultCrmIntegrationActions = accountSearchResultCrmIntegrationSlice.actions;

const accountSearchResultCrmIntegrationCacheSelector: CachedTableCacheSelector<Record<string, AccountCrmModule>>
    = state => state.accountSearchResult.crmIntegration.cache;
export const accountSearchResultCrmIntegrationDataSelector: CachedTableDataSelector<Record<string, AccountCrmModule>>
    = state => state.accountSearchResult.crmIntegration;
export const accountSearchResultCrmIntegrationResultSelector = getCachedTableResultSelector(
    accountSearchResultCrmIntegrationCacheSelector,
    accountSearchResultStateSelector,
);
